// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';

export interface ActionGetClientAPI extends Action {
    username: string;
}

export const getChatmeterSSOToken = (username: string): ActionGetClientAPI => ({
    type: ACTIONS.GET_CHATMETER_SSO_TOKEN,
    username
});

export interface ActionGetSSOTokenSuccess extends Action {
    ssoToken: string,
    error?: string,
    showInfoHeader?: boolean
}

export const getChatmeterSSOTokenSuccess = (ssoToken: string): ActionGetSSOTokenSuccess => ({
    type: ACTIONS.GET_CHATMETER_SSO_TOKEN_SUCCESS,
    ssoToken
});

export const getChatmeterSSOTokenError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_CHATMETER_SSO_TOKEN_ERROR,
    error
});

export const setShowHeader = (showInfoHeader: boolean): Action & { showInfoHeader: boolean } => ({
    type: ACTIONS.SHOW_INFO_HEADER,
    showInfoHeader
});